import {propertyOffer} from "@pg-mono/string-utils";

const CTA_DEFAULT = "Zobacz oferty";

export const HOMEMATCH_TINDER_PICKS_CARD_CONTENT = {
    CTA_DEFAULT,
    EMPTY_DESCRIPTION: "Trwają poszukiwania rekomendacji dla Ciebie. Jak tylko się pojawią, damy Ci znać!",
    EMPTY_TITLE: "Oferty są już w drodze...",
    SUBHEADING: "Na bazie Twoich poprzednich wyszukiwań",
    TITLE: "Mieszkania wybrane dla Ciebie",
    getCtaLabel: (offersCount: number | null) => (offersCount ? `Zobacz ${offersCount} ${propertyOffer.accusative(offersCount)}` : CTA_DEFAULT)
} as const;
import {propertyOffer} from "@pg-mono/string-utils";

const CTA_DEFAULT = "Zobacz oferty";

export const HOMEMATCH_TINDER_PICKS_CARD_CONTENT = {
    CTA_DEFAULT,
    EMPTY_DESCRIPTION: "Trwają poszukiwania rekomendacji dla Ciebie. Jak tylko się pojawią, damy Ci znać!",
    EMPTY_TITLE: "Oferty są już w drodze...",
    SUBHEADING: "Na bazie Twoich poprzednich wyszukiwań",
    TITLE: "Mieszkania wybrane dla Ciebie",
    getCtaLabel: (offersCount: number | null) => (offersCount ? `Zobacz ${offersCount} ${propertyOffer.accusative(offersCount)}` : CTA_DEFAULT)
} as const;
